import React, { useEffect, useState } from "react";
import { Button, Table } from "reactstrap";
import { Badge } from 'reactstrap';

export default function ReferActivities(props) {
    const [uncollapsed, setUncollapsed] = useState([]);

    useEffect(() => {
        if (props.referralActivity && props.referralActivity.length > 3) {
            setUncollapsed([...props.referralActivity.slice(0, 3)]);    
        } else {
            setUncollapsed([...props.referralActivity]);
        }
    }, []);

    const showMoreTx = () => {
        setUncollapsed([...props.referralActivity]);
    };

    const showLessTx = () => {
        setUncollapsed([...props.referralActivity.slice(0, 3)]);
    };

    return (
        <div style={props.isMobile ? {paddingBottom: '70px'}:{paddingBottom:'85px'}} className="recent-tx mt-4">
            <div className="d-flex justify-content-between">
                <p className="font-weight-semi-bold header">Activities</p>
            </div>
            <div className="table-wrapper">
                <Table striped  className="trans-table">
                    <thead className="thead">
                        <tr style={{backgroundColor:"#283A97"}}>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                #
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Email
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Type
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Sub Type
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Status
                            </th>
                            <th className="text-center text-white font-weight-semi-bold noBorder">
                                Benefit
                            </th>
                        </tr>
                    </thead>
                    <tbody className="tbodyStyle">
                        {uncollapsed &&
                            uncollapsed.length &&
                            uncollapsed.map((obj, index) => {
                                return (
                                    <>
                                    <tr className="text-center">
                                        <td className="noBorder">
                                            {index + 1}
                                        </td>
                                        <td className="noBorder">
                                            {obj.email ? obj.email : '--'}
                                        </td>
                                        <td className="text-capitalize noBorder">
                                            {obj.type ? obj.type : "--"}
                                        </td>
                                        <td className="text-capitalize noBorder">
                                            {obj.type ? obj.subType : "--"}
                                        </td>
                                        <td className="text-capitalize noBorder">
                                            {obj?.status === "done"
                                            ?
                                            <Badge 
                                                color="success" 
                                                className="p-2"
                                            >
                                                {obj.status}
                                            </Badge>
                                            : <Badge color="warning" className="p-2">Pending</Badge>
                                            } 
                                        </td>
                                        <td className="text-capitalize noBorder">
                                            {obj?.data?.benefitToReferrer 
                                                ? 
                                                <Badge 
                                                    color="success" 
                                                    className="p-2"
                                                >
                                                    {(obj?.data?.benefitToReferrer)?.oroNumber(2, true)}
                                                </Badge> 
                                                : "--"
                                            }
                                        </td>
                                    </tr>
                                    </>
                                );
                            })}
                    </tbody>
                </Table>
            </div>
            {uncollapsed && uncollapsed.length === 3 ? (
                <div className="text-center mt-2">
                    <Button outline
                        color="secondary"
                        className="view-btn"
                        onClick={showMoreTx}>
                        View More
                    </Button>
                </div>
            ) : (
                ""
            )}
            {uncollapsed && uncollapsed.length > 3 ? (
                <div className="text-center mt-2">
                    <Button outline
                        color="secondary"
                        className="text-center view-btn"
                        onClick={showLessTx}>
                        View Less
                    </Button>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
